import { Component, OnInit } from '@angular/core'
import { AdmytService } from '../../../services/admyt.service'
import { ParkingService } from '../../../services/parking.service'
import { Parking, ParkingStatus } from '@parkupp/core'
import { Router } from '@angular/router'

interface AdmytCenter {
    id: string
    name: string
    // Add other properties as needed based on the API response
}

interface CenterWithParkings extends AdmytCenter {
    relatedParkings: Parking[]
}

@Component({
    selector: 'app-admin-list-admyt-centers',
    templateUrl: './admin-list-admyt-centers.component.html',
    styleUrls: ['./admin-list-admyt-centers.component.scss'],
})
export class AdminListAdmytCentersComponent implements OnInit {
    centers: CenterWithParkings[] = []
    loading = true
    error: string | null = null

    constructor(private admytService: AdmytService, private parkingService: ParkingService, private router: Router) {}

    async ngOnInit() {
        await this.loadCentersWithParkings()
    }

    async loadCentersWithParkings() {
        try {
            this.loading = true
            this.error = null

            // Fetch Admyt centers
            const centersResult = await this.admytService.getCentres()
            const admytCenters: AdmytCenter[] = (centersResult.data as any) || []
            console.log(admytCenters)

            // Fetch only parkings that have admytCenter set
            const allParkings = await this.parkingService.listPromise({ status: ParkingStatus.PUBLISHED })
            const parkingsWithAdmytCenter = allParkings.filter((parking) => parking.admytCenter)

            // Map centers with their related parkings
            this.centers = admytCenters.map((center) => ({
                ...center,
                relatedParkings: parkingsWithAdmytCenter.filter((parking) => parking.admytCenter == center.id),
            }))

            this.loading = false
        } catch (error) {
            console.error('Failed to load Admyt centers:', error)
            this.error = 'Failed to load Admyt centers. Please try again.'
            this.loading = false
        }
    }

    viewParking(parking: Parking) {
        this.router.navigate(['/parking', parking.$key])
    }

    editParking(parking: Parking) {
        this.router.navigate(['/merchant', parking.merchantRef?.id, 'parking', parking.$key])
    }

    getTotalParkings(): number {
        return this.centers.reduce((total, center) => total + center.relatedParkings.length, 0)
    }

    getUnlinkedCenters(): number {
        return this.centers.filter(center => center.relatedParkings.length === 0).length
    }

    getAvgParkingsPerCenter(): number {
        if (this.centers.length === 0) return 0
        return this.getTotalParkings() / this.centers.length
    }
}
